module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.showSettingSuspendForm) ? _c('div', {
    staticClass: "bg-blue-grey-100 p-30 font-size-14 clearfix"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitSuspendStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuspendAlert),
      expression: "showSuspendAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successSuspendResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successSuspendResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.successSuspendResponse))]) : (_vm.errorSuspendResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorSuspendResponse))]) : _vm._e()]), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Setting Suspend")]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Mode")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSuspendMode),
      expression: "currentSuspendMode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.currentSuspendMode = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "auto"
    }
  }, [_vm._v("Auto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "suspend"
    }
  }, [_vm._v("Suspend")])])]), _vm._v(" "), (_vm.currentSuspendMode === 'suspend') ? _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('suspend_reason')
    }
  }, [_c('label', {
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Reason to client"), _c('span', {
    staticClass: "red-500"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamSuspend.suspend_reason),
      expression: "teamSuspend.suspend_reason"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.teamSuspend.suspend_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.teamSuspend.suspend_reason = $event.target.value
      }
    }
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-link pull-xs-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelSettingSuspendForm
    }
  }, [_vm._v("\n            Cancel\n          ")])])])])]) : _c('div', {
    staticClass: "bg-blue-grey-100 p-30 font-size-14"
  }, [_c('div', {
    staticClass: "counter counter-md text-xs-left"
  }, [_c('div', {
    staticClass: "counter-label text-uppercase m-b-5"
  }, [_vm._v("Setting Suspend")]), _vm._v(" "), _c('span', {
    staticClass: "counter-number"
  }, [_vm._v(" " + _vm._s(_vm.currentSuspendMode.toUpperCase()) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
  }, [(!_vm.team.has_reseller) ? _c('button', {
    staticClass: "btn btn-primary btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSettingSuspendForm
    }
  }, [_vm._v("Change setting\n        ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success pull-xs-left",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Update Plan\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99802840!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/SettingSuspend.vue
// module id = 553
// module chunks = 1